import React, { useEffect } from "react";
import { platformMe } from "../api/platform";
import { createAuthStore } from "../lib/createAuthStore";

export const usePlatformAuthStore = createAuthStore({
  tokenKey: "platform_token",
  userKey: "platform_user",
  fetchMe: platformMe,
  onLoadError: "clear",
});

export function PlatformAuthProvider({ children }) {
  const load = usePlatformAuthStore(s => s.load);
  useEffect(() => { load(); }, [load]);
  return <>{children}</>;
}

export function usePlatformAuth() {
  const s = usePlatformAuthStore();
  return {
    user: s.user, loading: s.loading, isAuthenticated: !!s.user,
    login: (token, userData) => s.setSession(token, null, userData),
    logout: s.clearSession,
  };
}
